import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play, ArrowUp, ArrowDown } from "lucide-react";

export function NumberGuess({ onScore }) {
  const [target, setTarget] = useState(0);
  const [guess, setGuess] = useState("");
  const [tries, setTries] = useState(0);
  const [hint, setHint] = useState("");
  const [running, setRunning] = useState(false);
  const [won, setWon] = useState(false);
  const reported = useRef(false);
  const [lo, setLo] = useState(1), [hi, setHi] = useState(100);

  const start = () => { setTarget(Math.floor(Math.random() * 100) + 1); setGuess(""); setTries(0); setHint("Guess 1–100"); setRunning(true); setWon(false); setLo(1); setHi(100); reported.current = false; };

  const submit = () => {
    const g = parseInt(guess, 10);
    if (!g || !running) return;
    const t = tries + 1; setTries(t);
    if (g === target) { setRunning(false); setWon(true); setHint(`Got it in ${t} tries!`); if (!reported.current) { reported.current = true; onScore?.(Math.max(100, 1100 - t * 100)); } }
    else if (g < target) { setHint("Higher! ⬆️"); setLo(Math.max(lo, g + 1)); }
    else { setHint("Lower! ⬇️"); setHi(Math.min(hi, g - 1)); }
    setGuess("");
  };

  return (
    <div className="flex flex-col items-center w-full max-w-sm text-center" data-testid="number-guess">
      <p className="font-mono text-neon-yellow mb-2">Tries: {tries}</p>
      {!running ? (
        <Button onClick={start} data-testid="ng-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase h-12 px-8 mt-4">
          <Play className="w-4 h-4 mr-2 fill-black" /> {won ? "Play Again" : "Start"}
        </Button>
      ) : (
        <>
          <p className="font-display font-black text-2xl mb-1 flex items-center gap-2 justify-center" data-testid="ng-hint">
            {hint.includes("Higher") && <ArrowUp className="text-neon-lime" />}
            {hint.includes("Lower") && <ArrowDown className="text-neon-pink" />}
            {hint}
          </p>
          <p className="font-mono text-zinc-500 text-sm mb-4">Range: {lo} – {hi}</p>
          <input value={guess} onChange={(e) => setGuess(e.target.value.replace(/\D/g, ""))} onKeyDown={(e) => e.key === "Enter" && submit()}
            data-testid="ng-input" inputMode="numeric" autoFocus
            className="w-40 bg-zinc-950 border-2 border-neon-cyan rounded-lg px-4 py-3 text-center font-display font-black text-3xl text-white outline-none mb-3" placeholder="?" />
          <Button onClick={submit} data-testid="ng-submit" className="bg-neon-pink text-white rounded-none font-bold uppercase">Guess</Button>
        </>
      )}
      <p className="text-zinc-500 text-xs font-mono mt-4">I'm thinking of a number 1–100. Find it in as few guesses as possible!</p>
    </div>
  );
}
